import {
  Box,
  Drawer,
  DrawerContent,
  DrawerOverlay,
  Flex,
  useColorModeValue,
  useDisclosure,
} from '@chakra-ui/react'
import * as React from 'react'
import { Logo } from './Logo'
import { Sidebar } from './Sidebar'
import { ToggleButton } from './ToggleButton'

export const Navbar = () => {
  const { isOpen, onToggle, onClose } = useDisclosure()
  return (
    <Box
      width="full"
      py="4"
      position={"fixed"}
      top={0}
      zIndex={100}
      left={0}
      right={0}
      px={{ base: "0", md: "8" }}
      bg="bg-surface"
      bgColor={"white"}
      boxShadow={useColorModeValue("sm", "sm-dark")}
    >
      <Flex justify="space-between">
        <img
          src={require("./../Utils/img/logo_green.jpeg")}
          alt="Logo UI"
          width={144}
          className='ps-2'
        />
        <ToggleButton
          isOpen={isOpen}
          aria-label="Open Menu"
          className='pe-3'
          onClick={onToggle}
        />
        <Drawer
          isOpen={isOpen}
          placement="left"
          onClose={onClose}
          isFullHeight
          preserveScrollBarGap
          // Only disabled for showcase
          trapFocus={false}
        >
          <DrawerOverlay />
          <DrawerContent>
            <Sidebar />
          </DrawerContent>
        </Drawer>
      </Flex>
    </Box>
  );
}
